import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8 col-12" }
const _hoisted_5 = {
  class: "div-contrato",
  titulo: 'Contrato'
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "col-lg-4 col-12" }
const _hoisted_8 = { class: "signature-container mb-3" }
const _hoisted_9 = { class: "signature-canvas-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_11 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_12 = { class: "d-grid gap-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_15 = { class: "signature-preview" }
const _hoisted_16 = ["src"]

import {  onMounted, reactive, ref } from "vue";
  import { useRoute, useRouter } from 'vue-router';

  import BreadCrumb from "@/components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/clientesContratosService";
  import { corrigirImagensContrato } from "@/utils/funcoes";

  //componentes
  import ReportView from "@/components/ReportView/Index.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Assinar',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();

  // Referencias para o canvas de assinatura
  const canvasRef = ref<HTMLCanvasElement>();
  const isDrawing = ref(false);
  const lastX = ref(0);
  const lastY = ref(0);

  var controle = reactive({
    filtros: {
      paginaAtual: 1,
      tamanhoPagina: 1
    } as unknown as service.Filtros,
    model: {} as service.Contrato,
    assinatura: {
      dataUrl: '', // Para armazenar a assinatura como base64
      confirmada: false
    },
    status: "",
    erro: "",
  })

  onMounted(async () => {
    pesquisar();
    setupCanvas();
  })

  async function pesquisar() {

    if (route.params.id) {
      controle.filtros.contratoId = parseInt(route.params.id as string);
    }
    
    service.obter(controle.filtros)
      .then(r => {
        controle.model = r[0];
      })
      .catch(erro => {
        controle.erro = erro;
      })
  }

  function setupCanvas() {
    const canvas = canvasRef.value;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Configurar estilo da linha
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    // Preencher fundo branco
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // Converte a posição do ponteiro (em pixels da tela) para coordenadas do canvas,
  // já que o canvas é exibido em largura maior que sua resolução interna (width/height do <canvas>).
  function posicaoNoCanvas(event: MouseEvent) {
    const canvas = canvasRef.value;
    const rect = canvas?.getBoundingClientRect();
    if (!canvas || !rect) return { x: 0, y: 0 };

    const escalaX = canvas.width / rect.width;
    const escalaY = canvas.height / rect.height;

    return {
      x: (event.clientX - rect.left) * escalaX,
      y: (event.clientY - rect.top) * escalaY,
    };
  }

  // Eventos do mouse
  function startDrawing(event: MouseEvent) {
    isDrawing.value = true;
    const pos = posicaoNoCanvas(event);
    lastX.value = pos.x;
    lastY.value = pos.y;
  }

  function draw(event: MouseEvent) {
    if (!isDrawing.value || !canvasRef.value) return;

    const ctx = canvasRef.value.getContext('2d');
    if (!ctx) return;

    const pos = posicaoNoCanvas(event);

    ctx.beginPath();
    ctx.moveTo(lastX.value, lastY.value);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();

    lastX.value = pos.x;
    lastY.value = pos.y;
  }

  function stopDrawing() {
    isDrawing.value = false;
  }

  // Eventos touch para dispositivos móveis
  function startTouchDrawing(event: TouchEvent) {
    event.preventDefault();
    const touch = event.touches[0];
    const mouseEvent = new MouseEvent('mousedown', {
      clientX: touch.clientX,
      clientY: touch.clientY
    });
    startDrawing(mouseEvent);
  }

  function touchDraw(event: TouchEvent) {
    event.preventDefault();
    const touch = event.touches[0];
    const mouseEvent = new MouseEvent('mousemove', {
      clientX: touch.clientX,
      clientY: touch.clientY
    });
    draw(mouseEvent);
  }

  function stopTouchDrawing(event: TouchEvent) {
    event.preventDefault();
    stopDrawing();
  }

  // Limpar assinatura
  function limparAssinatura() {
    const canvas = canvasRef.value;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    
    controle.assinatura.dataUrl = '';
    controle.assinatura.confirmada = false;
  }

  // Confirmar assinatura
  async function confirmarAssinatura() {

    console.log("salvando assinatura...");

    const canvas = canvasRef.value;
    if (!canvas) return;

    // Verificar se há algo desenhado no canvas
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    let hasDrawing = false;

    // Verificar se há pixels não brancos (indicando que algo foi desenhado)
    for (let i = 0; i < data.length; i += 4) {
      if (data[i] !== 255 || data[i + 1] !== 255 || data[i + 2] !== 255) {
        hasDrawing = true;
        break;
      }
    }

    if (!hasDrawing) {
      alert('Por favor, faça sua assinatura antes de confirmar.');
      return;
    }

    // Converter canvas para base64
    controle.assinatura.dataUrl = canvas.toDataURL('image/png');
    controle.assinatura.confirmada = true;

    try {
      controle.status = "Salvando assinatura...";
      
      // Aqui você faria a chamada para salvar a assinatura
      await service.SalvarAssinaturaBase64(
        { contratoId: controle.model.contratoId, 
          arquivoBase64: controle.assinatura.dataUrl }
        );

      controle.status = "Assinatura confirmada com sucesso!";
      
      // Redirecionar ou mostrar sucesso
      setTimeout(() => {
        router.push('/contratos/ver/' + controle.model.contratoId);
      }, 2000);
      
    } catch (error) {
      controle.erro = `Erro ao salvar assinatura: ${error}`;
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Assinatura do Contrato" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          class: "btn btn-sm btn-secondary float-end",
          to: '/contratos'
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
            _createTextVNode(" Fechar ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            innerHTML: _unref(corrigirImagensContrato)(_unref(controle).model.texto),
            class: "contrato"
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-label" }, "Faça sua assinatura abaixo:", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("canvas", {
              ref_key: "canvasRef",
              ref: canvasRef,
              width: "600",
              height: "280",
              class: "signature-canvas",
              onMousedown: startDrawing,
              onMousemove: draw,
              onMouseup: stopDrawing,
              onMouseleave: stopDrawing,
              onTouchstart: startTouchDrawing,
              onTouchmove: touchDraw,
              onTouchend: stopTouchDrawing
            }, null, 544),
            _cache[1] || (_cache[1] = _createElementVNode("small", { class: "text-muted" }, "Use o mouse ou toque para desenhar sua assinatura", -1))
          ])
        ]),
        (_unref(controle).status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(controle).erro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            onClick: confirmarAssinatura,
            disabled: _unref(controle).assinatura.confirmada
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(controle).assinatura.confirmada ? 'Assinatura Confirmada' : 'Confirmar Assinatura'), 1)
          ], 8, _hoisted_13),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: limparAssinatura
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-eraser me-1" }, null, -1),
            _createTextVNode(" Limpar Assinatura ", -1)
          ]))])
        ]),
        (_unref(controle).assinatura.confirmada && _unref(controle).assinatura.dataUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1)),
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Assinatura Confirmada:", -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  src: _unref(controle).assinatura.dataUrl,
                  alt: "Assinatura",
                  class: "img-fluid border"
                }, null, 8, _hoisted_16)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})